import { Link } from "react-router-dom";
import { Facebook, Instagram, LayoutDashboard, LogIn, Phone } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";

export const PHONE_DISPLAY = "91 010 57 48";
export const PHONE_HREF = "tel:+34910105748";

/** Dark strip above the logo: enrolment notice, phone and the way in. */
export default function HomeTopBar() {
  const { user } = useAuth();
  const ctaTarget = user ? (["gestion", "admin", "superadmin"].includes(user.role) ? "/admin" : "/dashboard") : "/login";
  const ctaLabel = user ? "Mi panel" : "Acceso a plataforma";

  return (
    <div className="bg-brand-ink text-white" data-testid="home-topbar">
      <div className="max-w-7xl mx-auto sm:px-6 flex flex-col sm:flex-row sm:items-center sm:justify-between sm:h-11 sm:gap-4">
        <p className="flex items-center justify-center gap-2.5 px-4 sm:px-0 py-2 sm:py-0 text-xs sm:text-[13px] font-semibold tracking-wide">
          <span className="w-2 h-2 rounded-full bg-brand ring-4 ring-brand/25" aria-hidden="true" />
          Matrícula abierta todo el año
        </p>
        <div className="flex items-center justify-between sm:justify-end gap-4 px-4 sm:px-0 border-t border-white/10 sm:border-0">
          <a
            href={PHONE_HREF}
            className="flex items-center gap-2 h-11 text-[13px] hover:text-brand transition-colors"
            data-testid="home-phone-link"
          >
            <Phone className="w-[15px] h-[15px] text-brand" />
            <span className="font-mono-data font-medium">{PHONE_DISPLAY}</span>
          </a>
          <span className="hidden sm:block w-px h-[18px] bg-white/20" aria-hidden="true" />
          <div className="hidden sm:flex items-center gap-2">
            <a
              href="https://www.instagram.com/laclaseencasa/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Síguenos en Instagram"
              className="w-7 h-7 rounded-full border border-white/25 flex items-center justify-center hover:text-brand hover:border-brand transition-colors"
              data-testid="home-instagram-link"
            >
              <Instagram className="w-3.5 h-3.5" />
            </a>
            <a
              href="https://www.facebook.com/laclaseencasa/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Síguenos en Facebook"
              className="w-7 h-7 rounded-full border border-white/25 flex items-center justify-center hover:text-brand hover:border-brand transition-colors"
              data-testid="home-facebook-link"
            >
              <Facebook className="w-3.5 h-3.5" />
            </a>
          </div>
          <Link to={ctaTarget}>
            <Button
              size="sm"
              className="bg-brand hover:bg-brand-hover text-white h-10 sm:h-[30px] px-3.5 font-medium"
              data-testid="cta-access-platform"
            >
              {user ? <LayoutDashboard className="w-3.5 h-3.5 mr-2" /> : <LogIn className="w-3.5 h-3.5 mr-2" />}
              {user ? ctaLabel : (
                <>
                  <span className="sm:hidden">Acceso</span>
                  <span className="hidden sm:inline">{ctaLabel}</span>
                </>
              )}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
